import React from 'react'
import { useSelector } from '~/store/hooks'

import GetNewsroomUrls from '~/utils/getNewsroomUrls'
import { WysiwygGql } from '~/components/core/Wysiwyg/WysiwygGql'
import { WysiwygApiRest } from '~/components/core/Wysiwyg/WysiwygApiRest'

const Wysiwyg = (props) => {
  const {
    classes = '',
    document,
    noClass = false,
    isProject,
    hasTitle = false,
  } = props

  const references = document?.references

  const lang = useSelector((state) => state.lang)
  const isFr = lang === 'fr'
  const newsroomUrls = GetNewsroomUrls()
  const wrapperClass = noClass ? null : `paragraph ${classes}`

  props = {
    ...props,
    lang,
    references,
    isFr,
    newsroomUrls,
  }

  return (
    <div className={wrapperClass}>
      {document?.raw && <WysiwygGql {...props} />}
      {!document?.raw && <WysiwygApiRest {...props} />}
    </div>
  )
}

export default Wysiwyg
